/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { formatDate, getSampleCsvHeadings, ROUTES } from '../../../shared/constants'
import { useHistory } from 'react-router'
import { useContentQuestion } from '../../../hooks/Others/LearningAndDevelopment/useContentQuestion'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useDownload } from '../../../hooks/Download/useDownload'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import QuestionAnswerDialog from '../../../components/Dialog/QuestionAnswerDialog'

export default function Quiz() {
  const { getAllContentQuestion, deleteManyContentQuestion, loading, paginate, updateContentQuestion } = useContentQuestion()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { contentQuestions, addNewQuiz } = useContext(OtherContext)
  //console.log('contentQuestions : ', contentQuestions)
  const [questions, setQuestions] = useState(false)
  const history = useHistory()
  //console.log('questions : ', questions)
  const [searchQuery, setSearchQuery] = useState('')
  const filterContentQuestion = contentQuestions
  const [page, setPage] = React.useState(1)
  const [openPrompt, setOpenPrompt] = React.useState(false)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllContentQuestion({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_CONTENTQUESTION')
  }, [])

  const handleChange = (event, value) => setPage(value)

  const handleSwitchChange = (item) => updateContentQuestion({ ...item, active: !item.active, contentQuestionId: item._id })

  let tableBody = []

  if (!loading && filterContentQuestion.length > 0) {
    tableBody = filterContentQuestion.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.contentQuestionCode },
        { value: item.name },
        { value: formatDate(item.startDate) },
        { value: formatDate(item.expiryDate) },
        { value: item.trainingCategory && item.trainingCategory.name },
        { value: item.trainingCategoryContent && item.trainingCategoryContent.name },
        { value: item.questions.length, onClick: () => setQuestions(item.questions), style: { cursor: 'pointer', color: 'blue', textDecoration: 'underline' } },

        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-content-question/${item._id}`) },
      ]
    })
  }
  const tempHeaders = getSampleCsvHeadings([
    'assesmentCode',
    'name',
    'startDate',
    'expiryDate',
    'trainingCategoryCode',
    'trainingCategoryContentCode',
    'question',
    'questionType',
    'options',
    'correctAnswer',
  ])

  const layoutProps = {
    heading: 'Manage Assessments',
    url: ROUTES.ADD_CONTENTQUESTION,
    editUrl: `/edit-content-question/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaderData: [],
    filename: 'contentQuestions',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'LEARNING',
    sampleName: 'sample_assesment',
    sheetName: 'assesment',
    tempHeaders: tempHeaders,
    addData: addNewQuiz,
    redirect: 'GET_ALL_CONTENTQUESTION',
    confirm: () => setOpenPrompt(true),
    openPrompt,
  }
  console.log({ openPrompt })
  return (
    <>
      {openPrompt && alert('Are You Sure')}
      <QuestionAnswerDialog questions={questions} open={questions.length > 0} handleClose={() => setQuestions(false)} />
      <CustomTableLayout
        tableHeadings={['Assessment Code', 'Name', 'start date', 'expiry date', 'training category', 'category content', 'total questions', 'Active', 'Info']}
        loading={loading}
        tableBody={tableBody}
        handleSwitchChange={handleSwitchChange}
        handlePageChange={handleChange}
        paginate={{ totalPage: noOfPages, page: page }}
        layoutProps={layoutProps}
        checkbox
        deleteMany={(val, setSelected) => deleteManyContentQuestion({ contentQuestionId: val }, setSelected)}
      />
    </>
  )
}
